<template>
    <div>
        <modal-cadu close :width="1131.52" v-model="valueData">
            <div slot="all" class="py-10 px-10">
                <div slot="header" class="primary1--text headline font-weight-bold">
                    COMPETÊNCIAS ANTERIORES - {{ type === 0 ? 'BENEFICIÁRIOS' : (type === 1 ? 'COOPERADOS' : 'COLABORADORES') }}
                </div>
                <div slot="body">
                    <v-row>
                        <v-col cols="12" sm="4">
                          <datepicker-cadu
                              inputTitle="Competência"
                              :inputValue="competencia"
                              v-model="showMenu"
                              @selected="data => selecionarData(data)"
                              @value="value => competencia = value"
                              :errorMessage="errorMessage"
                              :maxDate="dataMaximaCompetencia"
                          ></datepicker-cadu>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <TableCompetencia
                              :competencia="competencia"
                              :showFiltro="false"
                              @clickButton="gerenciaModal"
                              @error="errorModal"
                              @errorFiltro="errorMessage = 'erro'"
                              ref="tableCompetencia"
                            />
                        </v-col>
                    </v-row>
                </div>
                <div slot="footer">
                    <v-row align="end" justify="end">
                        <v-col cols="auto">
                            <button-cadu @click="$emit('input', false)" text="VOLTAR"/>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </modal-cadu>
        <error-modal
          :value="showError"
          @input="fecharModal"
          :errObj="errObj"
        />
        <SucessoModal
          :showSucess="showSucess"
          :genericMessage="genericMessage"
          @close="fecharSucesso"
        />
        <BeneficiariosModal
          @success="successModalBeneficiario"
          @input="inputModal"
          @error="errorModal"
          v-if="type === 0"
          ref="beneModal"
          :value="show"
          :mode="mode"
          :role="role"
        />
        <CooperadoresModal
          @success="successModalCooperado"
          @input="inputModal"
          @error="errorModal"
          v-if="type === 1"
          ref="coopModal"
          :value="show"
          :mode="mode"
        />
        <ColaboradoresModal
          @success="successModalColaborador"
          @input="inputModal"
          @error="errorModal"
          v-if="type === 2"
          ref="colaModal"
          :value="show"
          :mode="mode"
        />
        <overlay-loading v-model="loadingOverlay"/>
    </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import TableCompetencia from './TableCompetencia'
import BeneficiariosModal from './Shared/BeneficiariosModal'
import CooperadoresModal from './Shared/CooperadosModal'
import ColaboradoresModal from './Shared/ColaboradoresModal'

import Beneficiario from '@/services/Perfil/Beneficiario'
import Cooperado from '@/services/Perfil/Cooperado'
import Colaborador from '@/services/Perfil/Colaborador'
import Perfil from '@/services/Perfil/Perfil'

import { EventBus } from '@/services/EventBus/EventBus'

export default {
  components: {
    TableCompetencia,
    BeneficiariosModal,
    CooperadoresModal,
    ColaboradoresModal
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    type: {
      type: Number,
      required: true,
      note: 'tipo da modal, aceita 0, 1 ou 2'
    }
  },
  data () {
    return {
      valueData: this.value,
      competencia: '',
      show: false,
      mode: '',
      loadingOverlay: false,
      showSucess: false,
      showError: false,
      errObj: {},
      showMenu: false,
      errorMessage: '',
      role: '',
      dataMaximaCompetencia: '',
      tokenBearer: localStorage.getItem('tokenBearer')
    }
  },
  beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    this.opcaoEditar = localStorage.getItem('optionEdit')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
  },
  methods: {
    async fecharSucesso () {
      this.showSucess = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
    },
    fecharModal () {
      this.showError = false
      this.$nextTick(() => {
        this.valueData = true
        document.documentElement.style.overflow = 'hidden'
        // this.start()
      })
    },
    async editarPerfil (justificativa) {
      switch (this.type) {
        case 0:
          this.loadingOverlay = true
          await this.$refs.beneModal.putBeneficiario(justificativa)
          this.loadingOverlay = false
          break
        case 1:
          this.loadingOverlay = true
          await this.$refs.coopModal.putCooperado(justificativa)
          this.loadingOverlay = false
          break
        case 2:
          this.loadingOverlay = true
          await this.$refs.colaModal.putColaborador(justificativa)
          this.loadingOverlay = false
          break
        default:
          break
      }
    },
    selecionarData (data) {
      this.competencia = data
    },
    async filterCompetencia () {
      this.$nextTick(async () => {
        this.showMenu = false
        this.$refs.tableCompetencia.filterByCompetencia()
      })
    },
    successModal () {
      this.show = false
      this.showSucess = true
    },

    successModalCooperado () {
      this.type = 1
      this.successModal()
      EventBus.$emit('carregarTableCooperado', true)
    },

    successModalBeneficiario () {
      this.type = 0
      this.successModal()
      EventBus.$emit('carregarTableBeneficiario', true)
    },

    successModalColaborador () {
      this.type = 2
      this.successModal()
      EventBus.$emit('carregarTableColaborador', true)
    },
    errorModal (err) {
      this.show = false;

      if (err.response && err.response.data) {
        this.errObj.status = err.response.status;
        this.errObj.error = err.response.data.message;
      } else if (err.data) {
        this.errObj.status = err.data.status;
        this.errObj.error = err.data.message;
      }

      if (err.origin === "atualizacaoCadbenef") {
        this.errorMessage = "Não foi possível atualizar competência de Beneficiários, por favor tente mais tarde !";
      }
      this.showError = true;    
      console.error(err);  
    },
    async start () {
      this.competencia = ''
      this.$nextTick(() => {
        this.$refs.tableCompetencia.start(this.type)
      })
    },
    async gerenciaModal (obj) {
      let row = obj.row
      this.loadingOverlay = true

      if (obj.type !== 'view') {
        this.iniciaEdicao(row.id)
      }

      this.loadingOverlay = false
      this.mode = obj.type
      this.valueData = false
      this.show = true
      switch (this.type) {
        case 0:
          this.$refs.beneModal.start(row)
          break
        case 1:
          this.$refs.coopModal.start(row)
          break
        case 2:
          this.$refs.colaModal.start(row)
          break
        default:
          break
      }
    },
    async iniciaEdicao (idCompetencia) {
      const perfil = new Perfil(this.tokenBearer, this.$appConfig.config.API)

      const tipoPerfil = () => {
        switch (this.type) {
          case 0:
            return 'compBeneficiario'
          case 1:
            return 'compCooperado'
          case 2:
            return 'compColaborador'
        }
      }

      try {
        await perfil.editarCompetencia(tipoPerfil(), this.$idUnimed, idCompetencia)
      } catch (err) {
        this.valueData = false
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    inputModal () {
      this.show = false
      // this.$emit('input', true)

      this.$nextTick(() => {
        this.valueData = true
        if (!this.show) {
          this.start()
        }
      })
    },
    async ultimaCompetencia () {
      let cooperado = new Cooperado(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      let beneficiario = new Beneficiario(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      let colaborador = new Colaborador(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      let res = ''
      switch (this.type) {
        case 0:
          res = await beneficiario.getUltimoBeneficiario()
          break
        case 1:
          res = await cooperado.getUltimoCooperado()
          break
        case 2:
          res = await colaborador.getUltimoColaborador()
          break
        default:
          break
      }
      return res.data.competencia
    }
  },
  computed: {
    genericMessage () {
      return `Quantidade de ${this.name} atualizada com sucesso!`
    },
    name () {
      return this.type === 0 ? 'Beneficiarios' : (this.type === 1 ? 'Cooperados' : 'Colaboradores')
    }
  },
  watch: {
    competencia () {
      this.errorMessage = ''
      if (this.competencia.length === 7) {
        this.filterCompetencia()
      } else if (this.competencia.length === 0) {
        this.start()
      }
    },
    value () {
      this.valueData = this.value
    },
    async valueData () {
      this.showMenu = this.valueData ? this.showMenu : false
      if (this.valueData) {
        this.dataMaximaCompetencia = '01/' + await this.ultimaCompetencia()
      }
      this.$emit('input', this.valueData)
    }
  }
}
</script>
